import { render, staticRenderFns } from "./ConfigDashboard.vue?vue&type=template&id=702c92bf&scoped=true&"
import script from "./ConfigDashboard.vue?vue&type=script&lang=js&"
export * from "./ConfigDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ConfigDashboard.vue?vue&type=style&index=0&id=702c92bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702c92bf",
  null
  
)

export default component.exports